import { useIntl } from 'react-intl'
import HeadData from 'components/Common/HeadData'
import config from 'constants/config'
import { formatEscapeTypeLabel } from 'lib/offer/destinationProductPageUtils'

interface Props {
  holidayType?: string
  destination?: string
  imageId?: string
}

export default function HolidayTypeHeadData({ holidayType, destination, imageId }: Props) {
  const intl = useIntl()
  const category = holidayType ? formatEscapeTypeLabel(intl, holidayType) : intl.formatMessage({
    id: 'g-5eoHxUgBYSHnvs0Plk',
    defaultMessage: 'Holiday Offers',
    description: 'Social preview title fallback when the requested holiday theme is unknown',
  })
  const title = destination ? intl.formatMessage({
    id: 'uTtv_2seykWPPn13nEQ8',
    defaultMessage: '{holidayType} in {destination} - {brand}',
    description: 'Page and social preview title for a holiday theme filtered by destination',
  }, { holidayType: category, destination, brand: config.title }) : intl.formatMessage({
    id: '99GdK2LTJD5ANsI0AdeA',
    defaultMessage: '{holidayType} - {brand}',
    description: 'Page and social preview title for a holiday theme with no destination filter',
  }, { holidayType: category, brand: config.title })
  const description = intl.formatMessage({
    id: 'XY6fdCTJnXLPBCNBiHv2',
    defaultMessage: 'Explore our handpicked holiday offers for your next escape.',
    description: 'Social preview description for holiday theme landing pages and destination variants',
  })

  return <HeadData title={title} description={description} imageId={imageId} vertical="hotels" />
}
